import { render, staticRenderFns } from "./CreateStudioTeachers.vue?vue&type=template&id=2fa81879&scoped=true"
import script from "./CreateStudioTeachers.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudioTeachers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudioTeachers.vue?vue&type=style&index=0&id=2fa81879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa81879",
  null
  
)

export default component.exports